import React, { useState, useEffect, memo, useMemo } from 'react';
import { connect } from 'react-redux';
import Paginated from './Paginated';
import { Link } from 'react-router-dom';
import { getRedemption, clearRedemption } from '../../../actions/redemption';
import { getAllRedemption } from '../../../services/services';
import { decrypt } from '../../../utils/encodingdecoding';
import Header from "../../layout/Header";
import { COLUMNS } from './column';
import { getDisplayDate } from '../../../utils/helper';

const RedemptionList = memo(
    ({ getRedemption, Redemption, clearRedemption }) => {
        const [data, setData] = useState([]);
        const [transactionCount, setTransactionCount] = useState();
        const [loader, setLoader] = useState(true);

        let id = decrypt(localStorage.getItem('Id'));

        useEffect(() => {
            let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
            if (tempPageIndex === 1) {
                fetch();
            }
            // eslint-disable-next-line
        }, []);

        useEffect(() => {
            const ShortData = async () => {
                let tempData = Redemption?.data?.data;
                if (tempData) {
                    await tempData && (
                        tempData = tempData?.map((val) => ({
                            name: val?.customer?.name,
                            mobile: val?.customer?.mobile,
                            ordercode: val.transactionDetail?.ordercode,
                            ordervalue: val.transactionDetail?.ordervalue,
                            redemption_type:
                                val.transactionDetail?.redemption_type
                                    ?.split("_")[0]
                                    ?.charAt(0)
                                    .toUpperCase() +
                                val.transactionDetail?.redemption_type
                                    ?.split("_")[0]
                                    ?.slice(1),
                            title: val.transactionDetail?.itemlist
                                ?.map((item) => item.title)
                                .join(", "),
                            transactionDate: getDisplayDate(
                                val?.transactionDetail?.transactionDate
                            ),
                            transactionProcessedDate: val?.transactionDetail?.transactionDate,
                            action: <Link to={`/user-view/${val?.customer?.customercode}`}>
                                <i className="fa-solid fa-eye"></i> View Details
                            </Link>
                        }))
                    )

                    if (tempData) {
                        await tempData.sort(function (a, b) {
                            if (a.transactionProcessedDate === null) {
                                return 1;
                            } else if (b.transactionProcessedDate === null) {
                                return -1;
                            }
                            const dateA = new Date(a.transactionProcessedDate);
                            const dateB = new Date(b.transactionProcessedDate);
                            if (dateA < dateB) {
                                return 1;
                            } else if (dateA > dateB) {
                                return -1;
                            } else {
                                const timeA = dateA.getTime();
                                const timeB = dateB.getTime();
                                return timeB - timeA;
                            }
                        });
                    }
                    setData(tempData);
                }
            };

            ShortData();

        }, [Redemption]);

        const fetch = async () => {
            try {
                setLoader(true);
                // await clearRedemption();
                const token = JSON.parse(localStorage.getItem('token_gen'));
                let id = localStorage.getItem('Id');
                await getRedemption(token?.access_token, 1, 50);
                setLoader(false);
            } catch (err) {
                setLoader(false);
            }
        };

        const generateCSV = async () => {
            setLoader(true);

            try {
                const token = JSON.parse(localStorage.getItem('token_gen'));
                const id = localStorage.getItem('Id');

                if (!token?.access_token || !id) {
                    throw new Error('Missing token or ID');
                }
                const response = await getAllRedemption(
                    token.access_token, "", ""
                );
                const transactions = Redemption?.data?.data || [];
                const transformedData = transactions?.map((val) => {
                    return {
                        name: val.customer?.name,
                        mobile: val.customer?.mobile,
                        ordercode: val.transactionDetail?.ordercode,
                        ordervalue: val.transactionDetail?.ordervalue,
                        redemption_type:
                            val.transactionDetail?.redemption_type
                                ?.split("_")[0]
                                ?.charAt(0)
                                .toUpperCase() +
                            val.transactionDetail?.redemption_type
                                ?.split("_")[0]
                                ?.slice(1),
                        title: val.transactionDetail?.itemlist
                            ?.map((item) => item.title)
                            .join(", "),
                        transactionDate: getDisplayDate(
                            val?.transactionDetail?.transactionDate
                        ),
                    };
                });
                const csvHeaders = [
                    'Name',
                    'Mobile',
                    'Order',
                    'Order Code',
                    'Order Value',
                    'Title',
                    'Date'
                ];
                const csvData = [
                    csvHeaders,
                    ...transformedData?.reverse()?.map((row) => [
                        row.name,
                        row.mobile,
                        row.redemption_type,
                        row.ordercode,
                        row.ordervalue,
                        row.title,
                        row.transactionDate,
                    ]),
                ];
                const csvContent =
                    'data:text/csv;charset=utf-8,' +
                    csvData.map((row) => row.join(',')).join('\n');
                const encodedUri = encodeURI(csvContent);
                const link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', 'report.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error generating CSV:', error.message || error);
            } finally {
                setLoader(false);
            }
        };

        useEffect(() => {
            setTransactionCount(Redemption?.data?.totalCount);
        }, [Redemption]);

        return (
            <>
                <Header
                    name={'Redemption'}
                />
                {loader && (
                    <div className='mainPreloaderMain'>
                        <div className='mainPreloader'>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                )}
                <div className='dashboard__content'>
                    <div className='container-fluid'>
                        <div className='dashboard__transactionsCard'>
                            <div className='dashboard__header'>
                                <div className='dashboard__left'>
                                    <h4 id='transction_list'>
                                        All Redemptions
                                    </h4>
                                </div>
                                <div className='dashboard__right'>
                                    <button
                                        onClick={generateCSV}
                                        className='btn btn-default'>
                                        <i
                                            className='fa-solid fa-download'
                                            style={{ marginRight: '10px' }}></i>
                                        Download Redemption
                                    </button>
                                </div>
                            </div>
                            <div className='dashboard__body'>
                                <Paginated
                                    data={data}
                                    columns={COLUMNS}
                                    setLoader={setLoader}
                                    loader={loader}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    },
);

const mapStateToProps = (state) => ({
    Redemption: state.Redemption,
});
const mapDispatchToProps = {
    getRedemption,
    clearRedemption,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedemptionList);
